(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9603],{

/***/ 75747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ OfferList; }
/* harmony export */ });
/* harmony import */ var lodash_orderBy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75472);
/* harmony import */ var lodash_orderBy__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_orderBy__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _utils_bannerOptions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76962);
/* harmony import */ var _OfferTile__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51310);
/* harmony import */ var _ProductListItem__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57730);
/* harmony import */ var _ProductMenu_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(54820);
/* harmony import */ var _ProductMenu_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_ProductMenu_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);










function OfferList(_ref) {
  var offers = _ref.offers,
      _ref$waveSpecialProdu = _ref.waveSpecialProductsGrouped,
      waveSpecialProductsGrouped = _ref$waveSpecialProdu === void 0 ? [] : _ref$waveSpecialProdu,
      showBySelection = _ref.showBySelection;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      offersShown = _useState[0],
      setOffersShown = _useState[1];

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    getFilteredProducts();
  }, [showBySelection, offers, router.query]);
  if (!offers.length && !waveSpecialProductsGrouped.length) return null;

  function getSortedOffers() {
    if (showBySelection === _utils_bannerOptions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].catalog */ .Z.catalog) {
      return offers;
    }

    if (showBySelection === _utils_bannerOptions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].expensive */ .Z.expensive) {
      return lodash_orderBy__WEBPACK_IMPORTED_MODULE_0___default()(offers, 'price', 'desc');
    }

    if (showBySelection === _utils_bannerOptions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].cheap */ .Z.cheap) {
      return lodash_orderBy__WEBPACK_IMPORTED_MODULE_0___default()(offers, 'price', 'asc');
    }

    if (showBySelection === _utils_bannerOptions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].alphabetical */ .Z.alphabetical) {
      return lodash_orderBy__WEBPACK_IMPORTED_MODULE_0___default()(offers, 'name', 'asc');
    }
  }

  function getFilteredProducts() {
    var offersByBannerOptions = getSortedOffers();
    setOffersShown(offersByBannerOptions);
  }

  return (offersShown && offersShown.length !== 0 || waveSpecialProductsGrouped && waveSpecialProductsGrouped.length !== 0) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      className: (_ProductMenu_module_scss__WEBPACK_IMPORTED_MODULE_7___default().listHeader),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
        className: (_ProductMenu_module_scss__WEBPACK_IMPORTED_MODULE_7___default().listTitle),
        children: "\u03A3\u03B1\u03C2 \u03C3\u03C5\u03BC\u03C6\u03AD\u03C1\u03B5\u03B9"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
      className: (_ProductMenu_module_scss__WEBPACK_IMPORTED_MODULE_7___default().bannerContainer),
      children: [waveSpecialProductsGrouped.length !== 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
        children: waveSpecialProductsGrouped.map(function (p, index) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_ProductListItem__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            _product: p,
            itemListId: "Offers",
            itemListName: "\u03A0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AD\u03C2",
            positionInList: index + 1
          }, p._id);
        })
      }), offersShown.map(function (o) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_OfferTile__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
          offer: o
        }, o._id);
      })]
    })]
  });
}

/***/ }),

/***/ 51310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ OfferTile; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(59499);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _store_cart__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88362);
/* harmony import */ var _store_orderLimitations__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39519);
/* harmony import */ var _utils_products__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1003);
/* harmony import */ var _RoundButton_ButtonCart__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(75547);
/* harmony import */ var _OfferTile_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(92477);
/* harmony import */ var _OfferTile_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_OfferTile_module_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(22838);
/* harmony import */ var _ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);













var DISABLED_OFFER_WARNING = 'Το συγκεκριμένο προϊόν δεν είναι πλέον διαθέσιμο';
function OfferTile(_ref) {
  var _cn;

  var offer = _ref.offer,
      isHomeOffer = _ref.isHomeOffer,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var priceString = "\u20AC ".concat((offer.price / 100).toFixed(2), " ");

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      displayInfoWindow = _useState[0],
      setDisplayInfoWindow = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({}),
      productLimit = _useState2[0],
      setProductLimit = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(''),
      productQuantity = _useState3[0],
      setProductQuantity = _useState3[1];

  function offerUOM(_offer) {
    if (_offer.products.length !== 0 || _offer.groups.length !== 0) {
      return 'το σετ';
    }

    return 'το τεμάχιο';
  }

  function productsLimitReachedWrapper(limit) {
    var quantity = _store_cart__WEBPACK_IMPORTED_MODULE_4__/* .productsQuantities.getValue */ .UU.getValue();
    (0,_utils_products__WEBPACK_IMPORTED_MODULE_6__/* .productsLimitReached */ .B2)(offer, quantity[offer._id], setDisplayInfoWindow, limit);
  }

  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function () {
    var productsQuantities$ = _store_cart__WEBPACK_IMPORTED_MODULE_4__/* .productsQuantities.subscribe */ .UU.subscribe(function (productQuantities) {
      var _productQuantity = productQuantities[offer._id];
      setProductQuantity(_productQuantity);
    });
    var orderLimitations$ = _store_orderLimitations__WEBPACK_IMPORTED_MODULE_5__/* ["default"].subscribe */ .Z.subscribe(function (orderLimitations) {
      var limit = (0,_utils_products__WEBPACK_IMPORTED_MODULE_6__/* .getProductOrderLimit */ .sA)(orderLimitations, offer);
      setProductLimit(limit);
    });
    return function () {
      orderLimitations$.unsubscribe();
      productsQuantities$.unsubscribe();
    };
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function () {
    if (!productLimit) return;
    productsLimitReachedWrapper(productLimit);
  }, [productQuantity, productLimit]);
  var imgSrc = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(offer, 'image.webSmallThumb', '');
  var searchResultsImage = offer.image.baseUrl + offer.image.primary;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().productItem), (_cn = {}, (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_cn, (_OfferTile_module_scss__WEBPACK_IMPORTED_MODULE_11___default().offerProductItem), isHomeOffer), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_cn, (_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().disabledProduct), disabled), _cn)),
    title: disabled ? DISABLED_OFFER_WARNING : undefined,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
      href: (0,_utils_products__WEBPACK_IMPORTED_MODULE_6__/* .offerLink */ .m9)(offer),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("a", {
        className: (_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().productLink),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
          className: (_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().layoutSmall),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("header", {
            className: (_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().header),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
              className: (_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().badgeOffer),
              children: offer.webSticker
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("img", {
              loading: "lazy",
              src: imgSrc || searchResultsImage,
              width: "200",
              height: "200",
              className: (_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().productImage),
              alt: offer.name
            }), displayInfoWindow && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
              className: (_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().infoWindow),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("p", {
                children: "\u0388\u03C7\u03B5\u03B9\u03C2 \u03C6\u03C4\u03AC\u03C3\u03B5\u03B9 \u03C4\u03B7\u03BD \u03BC\u03AD\u03B3\u03B9\u03C3\u03C4\u03B7 \u03C0\u03BF\u03C3\u03CC\u03C4\u03B7\u03C4\u03B1 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03BF\u03C2"
              })
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("main", {
            className: (_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().main),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("p", {
              className: (_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().title),
              children: offer.name
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("p", {
              className: (_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().titleDesc),
              title: offer.description,
              children: offer.description
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("p", {
              className: (_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().description),
              children: [priceString, offerUOM(offer)]
            })]
          })]
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().btnContainer), (_OfferTile_module_scss__WEBPACK_IMPORTED_MODULE_11___default().btnContainer)),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
        className: (_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().priceFooter),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
          className: (_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().finalPriceContainer),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("p", {
            className: (_ProductListItem_module_scss__WEBPACK_IMPORTED_MODULE_9___default().finalPrice),
            children: priceString
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_RoundButton_ButtonCart__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        product: offer,
        productLimit: productLimit,
        quantity: productQuantity,
        isEditable: true,
        removed: disabled
      })]
    })]
  });
}

/***/ }),

/***/ 6200:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Search; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(27812);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(50029);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var react_infinite_scroller__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(246);
/* harmony import */ var react_infinite_scroller__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react_infinite_scroller__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _api_Search__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(51751);
/* harmony import */ var _components_Buttons_Buttons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3805);
/* harmony import */ var _components_CategoriesAside_CategoriesAside__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(6551);
/* harmony import */ var _components_CategoriesBanner_CategoriesBanner__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(11848);
/* harmony import */ var _components_CategoriesSelect_CategoriesSelect__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(16723);
/* harmony import */ var _components_CustomMetaHead__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(92536);
/* harmony import */ var _components_DeliveryBanner_DeliveryBanner__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(54196);
/* harmony import */ var _components_FavoritesAside_FavoritesAside__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(79255);
/* harmony import */ var _components_Footer_Footer__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(31875);
/* harmony import */ var _components_Header_Header__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(3266);
/* harmony import */ var _components_Navigation_Navigation__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(86894);
/* harmony import */ var _components_ProductsMenu_OfferList__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(75747);
/* harmony import */ var _components_ProductsMenu_ProductListItem__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(57730);
/* harmony import */ var _components_ProductsMenu_ProductMenu_module_scss__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(54820);
/* harmony import */ var _components_ProductsMenu_ProductMenu_module_scss__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(_components_ProductsMenu_ProductMenu_module_scss__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var _store_cart__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(88362);
/* harmony import */ var _store_categories__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(9266);
/* harmony import */ var _store_deliveryMode__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(34525);
/* harmony import */ var _store_loader__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(58766);
/* harmony import */ var _store_productsSearch__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(68960);
/* harmony import */ var _store_productsSort__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(43660);
/* harmony import */ var _utils_bannerOptions__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(76962);
/* harmony import */ var _utils_browser__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(79974);
/* harmony import */ var _utils_objectManipulation__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(18745);
/* harmony import */ var _utils_products__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(1003);
/* harmony import */ var _products_products_module_scss__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(22097);
/* harmony import */ var _products_products_module_scss__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(_products_products_module_scss__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var _search_module_scss__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(23496);
/* harmony import */ var _search_module_scss__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(_search_module_scss__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(85893);





function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




































var searchText = {
  el: {
    empty: 'Δεν βρέθηκαν αποτελέσματα για τον όρο ',
    emptyButton: 'Επιστροφή στην αρχική',
    products: 'Προϊόντα'
  }
};
var __N_SSG = true;
function Search(_ref) {
  var _router$query8, _router$query9, _router$query10, _router$query11, _router$query12, _router$query13, _router$query14, _router$query15, _router$query16;

  var footerLinks = _ref.footerLinks,
      navigation = _ref.navigation,
      meta = _ref.meta;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
  var slug = [];

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(''),
      deliveryMode = _useState[0],
      setDeliveryMode = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false),
      isCartVisible = _useState2[0],
      setIsCartVisible = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false),
      isForced = _useState3[0],
      setIsForced = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false),
      hasError = _useState4[0],
      setHasError = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(_utils_bannerOptions__WEBPACK_IMPORTED_MODULE_27__/* ["default"].catalog */ .Z.catalog),
      showBySelection = _useState5[0],
      setShowBySelection = _useState5[1];

  var _useState6 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false),
      isFetching = _useState6[0],
      setIsFetching = _useState6[1];

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(0),
      page = _useState7[0],
      setPage = _useState7[1];

  var _useState8 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(1),
      totalPages = _useState8[0],
      setTotalPages = _useState8[1];

  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(0),
      totalCount = _useState9[0],
      setTotalCount = _useState9[1];

  var _useState10 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)({}),
      groupedByCategoryProducts = _useState10[0],
      setGroupedByCategoryProducts = _useState10[1];

  var _useState11 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]),
      renderedCategories = _useState11[0],
      setRenderedCategories = _useState11[1];

  var _useState12 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]),
      liveOffers = _useState12[0],
      setLiveOffers = _useState12[1];

  var _useState13 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(["900"]),
      collectionTypes = _useState13[0],
      setCollectionTypes = _useState13[1];

  var _useState14 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(true),
      hasMore = _useState14[0],
      setHasMore = _useState14[1];

  var _useState15 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)({}),
      categoriesMap = _useState15[0],
      setCategoriesMap = _useState15[1];

  var _useState16 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]),
      waveSpecialProductsGrouped = _useState16[0],
      setWaveSpecialProductsGrouped = _useState16[1];

  function getResults() {
    return _getResults.apply(this, arguments);
  }

  function _getResults() {
    _getResults = (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
      var _router$query17, _router$query18;

      var _collectionTypes,
          _page,
          results,
          _args = arguments;

      return _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _collectionTypes = _args.length > 0 && _args[0] !== undefined ? _args[0] : collectionTypes;
              _page = _args.length > 1 && _args[1] !== undefined ? _args[1] : 0;
              _store_loader__WEBPACK_IMPORTED_MODULE_24__/* ["default"].addEvent */ .Z.addEvent('GET_SEARCH_RESULTS');
              setIsFetching(true);
              setHasError(false);
              _context.next = 7;
              return (0,_api_Search__WEBPACK_IMPORTED_MODULE_8__/* .getSearchResults */ .B)(router === null || router === void 0 ? void 0 : (_router$query17 = router.query) === null || _router$query17 === void 0 ? void 0 : _router$query17.product, _collectionTypes, router === null || router === void 0 ? void 0 : (_router$query18 = router.query) === null || _router$query18 === void 0 ? void 0 : _router$query18.category, _page, _store_productsSort__WEBPACK_IMPORTED_MODULE_26__/* ["default"].getValue */ .Z.getValue());

            case 7:
              results = _context.sent;
              setIsFetching(false);
              _store_loader__WEBPACK_IMPORTED_MODULE_24__/* ["default"].removeEvent */ .Z.removeEvent('GET_SEARCH_RESULTS');
              return _context.abrupt("return", results);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _getResults.apply(this, arguments);
  }

  function getResultsWrapper() {
    return _getResultsWrapper.apply(this, arguments);
  }

  function _getResultsWrapper() {
    _getResultsWrapper = (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2() {
      var _router$query19;

      var forced,
          _collectionTypes,
          _results,
          results,
          _args2 = arguments;

      return _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              forced = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : false;
              _collectionTypes = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : collectionTypes;

              if (router !== null && router !== void 0 && (_router$query19 = router.query) !== null && _router$query19 !== void 0 && _router$query19.product) {
                _context2.next = 4;
                break;
              }

              return _context2.abrupt("return");

            case 4:
              if (!forced) {
                _context2.next = 9;
                break;
              }

              _context2.next = 7;
              return getResults(_collectionTypes, 0);

            case 7:
              _results = _context2.sent;
              return _context2.abrupt("return", forcedResults(_results));

            case 9:
              if (!(isFetching || totalPages <= page)) {
                _context2.next = 12;
                break;
              }

              setHasMore(totalPages > page);
              return _context2.abrupt("return");

            case 12:
              _context2.next = 14;
              return getResults(_collectionTypes, page);

            case 14:
              results = _context2.sent;

              if (!isForced) {
                convertResults(results);
              }

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _getResultsWrapper.apply(this, arguments);
  }

  function manipulateResults(isFirstFetch, results) {
    var prevCategories = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var prevCategoryProducts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var prevLiveOffers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

    if (results.error) {
      resetAllState();
      setHasError(true);
      return;
    }

    setHasError(results.totalCount === 0);
    setTotalCount(results.totalCount);
    setTotalPages(results.totalPages);
    var productsByCategory = (0,_utils_products__WEBPACK_IMPORTED_MODULE_29__/* .getProductsGroupedByCategory */ .Gt)(results.data.products);
    var renderedCategoriesKeys = Object.keys(productsByCategory);
    var mergedCategoriesKeys = [].concat((0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)(prevCategories), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)(renderedCategoriesKeys));
    var uniqueMergedCategoriesKeys = (0,_utils_objectManipulation__WEBPACK_IMPORTED_MODULE_28__/* .getUniqueValuesArray */ .MR)(mergedCategoriesKeys);
    var concatProductsByCategory = (0,_utils_products__WEBPACK_IMPORTED_MODULE_29__/* .getConcatProductsByCategory */ .fM)(prevCategoryProducts, productsByCategory);
    var mergedOffers = [].concat((0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)(prevLiveOffers), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)(results.data.offers));
    setLiveOffers(mergedOffers);
    findWaveProductsOffers(results.data.products, isFirstFetch);
    setGroupedByCategoryProducts(concatProductsByCategory);
    setRenderedCategories(uniqueMergedCategoriesKeys);
    setIsForced(false);
  }

  function forcedResults(results) {
    setPage(1);
    manipulateResults(true, results);
  }

  function convertResults(results) {
    setPage(page + 1);
    manipulateResults(false, results, renderedCategories, groupedByCategoryProducts, liveOffers);
  }

  function onChangeOrderBy(event) {
    var _router$query;

    _store_productsSort__WEBPACK_IMPORTED_MODULE_26__/* ["default"].update */ .Z.update(event.target.value);
    updateURL(event.target.value, router === null || router === void 0 ? void 0 : (_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.product);
  }

  function onScrollProducts() {
    getResultsWrapper();
  }

  function updateURL() {
    var _router$query2, _router$query3, _router$query4;

    var sortBy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : router === null || router === void 0 ? void 0 : (_router$query2 = router.query) === null || _router$query2 === void 0 ? void 0 : _router$query2.sortBy;
    var product = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : router === null || router === void 0 ? void 0 : (_router$query3 = router.query) === null || _router$query3 === void 0 ? void 0 : _router$query3.product;
    var category = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : router === null || router === void 0 ? void 0 : (_router$query4 = router.query) === null || _router$query4 === void 0 ? void 0 : _router$query4.category;

    var params = _objectSpread(_objectSpread(_objectSpread({}, (0,_utils_objectManipulation__WEBPACK_IMPORTED_MODULE_28__/* .getValidObject */ .t9)('product', product)), (0,_utils_objectManipulation__WEBPACK_IMPORTED_MODULE_28__/* .getValidObject */ .t9)('sortBy', sortBy)), (0,_utils_objectManipulation__WEBPACK_IMPORTED_MODULE_28__/* .getValidObject */ .t9)('category', category));

    router.push({
      pathname: '/search',
      query: params
    }, undefined, {
      shallow: false
    });
  }

  function resetAllState() {
    setLiveOffers([]);
    setWaveSpecialProductsGrouped([]);
    var resetGroupedByCategoryProducts = (0,_utils_objectManipulation__WEBPACK_IMPORTED_MODULE_28__/* .resetDynamicObject */ .IQ)(groupedByCategoryProducts);
    setGroupedByCategoryProducts(_objectSpread(_objectSpread({}, groupedByCategoryProducts), resetGroupedByCategoryProducts));
    setRenderedCategories([]);
    setTotalPages(1);
    setPage(0);
    setHasMore(true);
  }

  function findWaveProductsOffers(products, isFirstFetch) {
    if (!products.length) return;
    var productInCategory = products.filter(function (p) {
      return p.offerType === 'web-only-amount' || p.offerType === 'web-only-percentage';
    });
    var productsInCategory = isFirstFetch ? (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)(productInCategory) : [].concat((0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)(waveSpecialProductsGrouped), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)(productInCategory));
    setWaveSpecialProductsGrouped((0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)(new Set(productsInCategory)));
  }

  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    var categories$ = _store_categories__WEBPACK_IMPORTED_MODULE_22__/* ["default"].subscribe */ .Z.subscribe(function (_categories) {
      if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default()(_categories)) {
        var categoriesNameMap = (0,_utils_objectManipulation__WEBPACK_IMPORTED_MODULE_28__/* .getMapFromObjectArray */ .q3)(_categories, '_id', 'name');
        setCategoriesMap(categoriesNameMap);
      }
    });
    var subscriptionDeliveryMode = _store_deliveryMode__WEBPACK_IMPORTED_MODULE_23__/* ["default"].subscribe */ .Z.subscribe(function (_mode) {
      setDeliveryMode(_mode);

      var _collectionTypes = _store_deliveryMode__WEBPACK_IMPORTED_MODULE_23__/* ["default"].getCollectionAsNumber */ .Z.getCollectionAsNumber(_mode);

      setCollectionTypes(_collectionTypes);
      setIsFetching(false);

      if (collectionTypes.toString() !== _collectionTypes.toString()) {
        resetAllState();
        setIsForced(true); // handle initial state update when collection types can change in a sec
        // starts with 900 and if store has local collection 900 & 9002 is updating
        // if we fire both requests without time out, we will know which one will respond last

        setTimeout(function () {
          return getResultsWrapper(true, _collectionTypes);
        }, 500);
      }
    });
    var sortBy$ = _store_productsSort__WEBPACK_IMPORTED_MODULE_26__/* ["default"].subscribe */ .Z.subscribe(setShowBySelection);
    var isCartVisible$ = _store_cart__WEBPACK_IMPORTED_MODULE_21__/* ["default"].getIsVisble$ */ .ZP.getIsVisble$().subscribe(setIsCartVisible);
    return function () {
      categories$.unsubscribe();
      isCartVisible$.unsubscribe();
      sortBy$.unsubscribe();
      subscriptionDeliveryMode.unsubscribe();
    };
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    var _router$query5, _router$query6, _router$query7;

    _store_productsSort__WEBPACK_IMPORTED_MODULE_26__/* ["default"].update */ .Z.update((router === null || router === void 0 ? void 0 : (_router$query5 = router.query) === null || _router$query5 === void 0 ? void 0 : _router$query5.sortBy) || 'default');
    _store_productsSearch__WEBPACK_IMPORTED_MODULE_25__/* ["default"].updateQuery */ .Z.updateQuery((router === null || router === void 0 ? void 0 : (_router$query6 = router.query) === null || _router$query6 === void 0 ? void 0 : _router$query6.product) || '');
    resetAllState();

    if (router !== null && router !== void 0 && (_router$query7 = router.query) !== null && _router$query7 !== void 0 && _router$query7.product) {
      setIsForced(true);
      getResultsWrapper(true);
    }
  }, [router.isReady, router === null || router === void 0 ? void 0 : (_router$query8 = router.query) === null || _router$query8 === void 0 ? void 0 : _router$query8.sortBy, router === null || router === void 0 ? void 0 : (_router$query9 = router.query) === null || _router$query9 === void 0 ? void 0 : _router$query9.product, router === null || router === void 0 ? void 0 : (_router$query10 = router.query) === null || _router$query10 === void 0 ? void 0 : _router$query10.category]);
  if (!(0,_utils_browser__WEBPACK_IMPORTED_MODULE_33__/* .isBrowser */ .jU)()) return null;
  if (!(router !== null && router !== void 0 && (_router$query11 = router.query) !== null && _router$query11 !== void 0 && _router$query11.product)) return null;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_components_CustomMetaHead__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
      meta: meta
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)("div", {
      className: (_search_module_scss__WEBPACK_IMPORTED_MODULE_34___default().headerContainer),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_components_Header_Header__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
        navigation: navigation,
        isEnabled: true
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_components_Navigation_Navigation__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
      navigation: navigation
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_components_DeliveryBanner_DeliveryBanner__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_components_CategoriesSelect_CategoriesSelect__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
      slug: slug
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_products_products_module_scss__WEBPACK_IMPORTED_MODULE_35___default().mainContent), (_products_products_module_scss__WEBPACK_IMPORTED_MODULE_35___default().mainList), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, (_products_products_module_scss__WEBPACK_IMPORTED_MODULE_35___default().spaceOpenCart), isCartVisible)),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsxs)("div", {
        className: (_products_products_module_scss__WEBPACK_IMPORTED_MODULE_35___default().listBannerSearch),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)("div", {
          className: (_products_products_module_scss__WEBPACK_IMPORTED_MODULE_35___default().sticky),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_components_CategoriesBanner_CategoriesBanner__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
            onChangeOrderBy: onChangeOrderBy,
            showBySelection: showBySelection,
            categoryName: "\u0391\u03BD\u03B1\u03B6\u03AE\u03C4\u03B7\u03C3\u03B7 \u03B3\u03B9\u03B1 '".concat(router === null || router === void 0 ? void 0 : (_router$query12 = router.query) === null || _router$query12 === void 0 ? void 0 : _router$query12.product, "'"),
            deliveryMode: deliveryMode,
            isSearch: true,
            isProductList: true,
            term: router === null || router === void 0 ? void 0 : (_router$query13 = router.query) === null || _router$query13 === void 0 ? void 0 : _router$query13.product,
            hideOrderBy: !(router !== null && router !== void 0 && (_router$query14 = router.query) !== null && _router$query14 !== void 0 && _router$query14.category),
            numOfProducts: totalCount,
            slug: slug,
            onlyProducts: !(router !== null && router !== void 0 && (_router$query15 = router.query) !== null && _router$query15 !== void 0 && _router$query15.category) && "".concat(totalCount, " ").concat(searchText.el.products)
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsxs)("div", {
          className: (_products_products_module_scss__WEBPACK_IMPORTED_MODULE_35___default().mainContent),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)("div", {
            className: (_search_module_scss__WEBPACK_IMPORTED_MODULE_34___default().hideOnSmallScreen),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsxs)("div", {
              className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_products_products_module_scss__WEBPACK_IMPORTED_MODULE_35___default().sticky), (_products_products_module_scss__WEBPACK_IMPORTED_MODULE_35___default().categoriesAsideTop)),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_components_FavoritesAside_FavoritesAside__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_components_CategoriesAside_CategoriesAside__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                slug: slug
              })]
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsxs)("div", {
            className: (_search_module_scss__WEBPACK_IMPORTED_MODULE_34___default().defaultContainer),
            children: [(!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default()(liveOffers) || !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default()(waveSpecialProductsGrouped)) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)("div", {
              className: (_products_products_module_scss__WEBPACK_IMPORTED_MODULE_35___default().listSearch),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_components_ProductsMenu_OfferList__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                offers: liveOffers,
                showBySelection: showBySelection,
                waveSpecialProductsGrouped: waveSpecialProductsGrouped
              })
            }), !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default()(renderedCategories) && !isForced && renderedCategories.map(function (renderedCategory) {
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsxs)("div", {
                className: (_products_products_module_scss__WEBPACK_IMPORTED_MODULE_35___default().listSearch),
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)("div", {
                  className: (_components_ProductsMenu_ProductMenu_module_scss__WEBPACK_IMPORTED_MODULE_36___default().listHeader),
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)("h2", {
                    className: (_components_ProductsMenu_ProductMenu_module_scss__WEBPACK_IMPORTED_MODULE_36___default().listTitle),
                    children: categoriesMap[renderedCategory]
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)((react_infinite_scroller__WEBPACK_IMPORTED_MODULE_7___default()), {
                  threshold: 440 // 440px is the height of a category with 1 row of products
                  ,
                  hasMore: hasMore // keep it like this until we purge the logic of multiple async calls to local db for products
                  ,
                  initialLoad: false,
                  loader: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)("div", {}, "0"),
                  loadMore: onScrollProducts,
                  className: (_search_module_scss__WEBPACK_IMPORTED_MODULE_34___default().infiniteScrollContainer),
                  children: groupedByCategoryProducts[renderedCategory].map(function (product, index) {
                    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_components_ProductsMenu_ProductListItem__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                      _product: product,
                      productsQuantities: _store_cart__WEBPACK_IMPORTED_MODULE_21__/* .productsQuantities.getValue */ .UU.getValue()[product._id],
                      itemListId: "Search",
                      itemListName: "Search",
                      positionInList: index + 1
                    }, product._id);
                  })
                })]
              }, renderedCategory);
            }), lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default()(renderedCategories) && hasError && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsxs)("div", {
              className: (_search_module_scss__WEBPACK_IMPORTED_MODULE_34___default().imageContainer),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)("img", {
                className: (_search_module_scss__WEBPACK_IMPORTED_MODULE_34___default().img),
                width: "200",
                height: "200",
                src: "/assets/".concat("kritikos", "/").concat("kritikos", "-empty-search.png"),
                alt: "empty results"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)("p", {
                className: (_search_module_scss__WEBPACK_IMPORTED_MODULE_34___default().emptyText),
                children: "".concat(searchText.el.empty, " \"").concat(router === null || router === void 0 ? void 0 : (_router$query16 = router.query) === null || _router$query16 === void 0 ? void 0 : _router$query16.product, "\"")
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                href: "/",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)("a", {
                  className: (_search_module_scss__WEBPACK_IMPORTED_MODULE_34___default().link),
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_components_Buttons_Buttons__WEBPACK_IMPORTED_MODULE_9__/* .PrimaryButton */ .KM, {
                    children: searchText.el.emptyButton
                  })
                })
              })]
            })]
          })]
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_30__.jsx)(_components_Footer_Footer__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
      footerLinks: footerLinks
    })]
  });
}

/***/ }),

/***/ 32252:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search",
      function () {
        return __webpack_require__(6200);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 92477:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"offerProductItem":"OfferTile_offerProductItem__OLcDJ","btnContainer":"OfferTile_btnContainer__uEgA_"};

/***/ }),

/***/ 54820:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"ProductMenu_listContainer__ks2Ns","infiniteList":"ProductMenu_infiniteList__8zE3B","notSticky":"ProductMenu_notSticky__Q5FIP","listTitle":"ProductMenu_listTitle__PxrUW","listHeader":"ProductMenu_listHeader__Crgmj","options":"ProductMenu_options__soiZ6","bannerContainer":"ProductMenu_bannerContainer__V5Oou","categoryContainer":"ProductMenu_categoryContainer__TQ0Xh","selectBrand":"ProductMenu_selectBrand__blXFc","centerNoProducts":"ProductMenu_centerNoProducts__LB64y","bannerLink":"ProductMenu_bannerLink__jJoSR","hideOnSmallScreen":"ProductMenu_hideOnSmallScreen__L_Gdk","visibilityHidden":"ProductMenu_visibilityHidden__6Pghu"};

/***/ }),

/***/ 22097:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"products_main__TtvX6","mainLeft":"products_mainLeft__Zq_Pd","listContainer":"products_listContainer___Yoas","listBanner":"products_listBanner__Vqeci","mainContent":"products_mainContent__SRXIi","defaultContainer":"products_defaultContainer__XTPoZ","listBannerSearch":"products_listBannerSearch__xE6mU","listSearch":"products_listSearch__oQH6E","mainList":"products_mainList__SPxdH","sticky":"products_sticky__gf_n1","categoriesAsideProductDetails":"products_categoriesAsideProductDetails__b9XMz","spaceOpenCart":"products_spaceOpenCart__StTkZ","categoriesAsideTop":"products_categoriesAsideTop__9uz0r","productsListContainer":"products_productsListContainer__IY8_d","offerListContainer":"products_offerListContainer__7kkh6","offerListWrapper":"products_offerListWrapper__CzhiT","productScrollingContainer":"products_productScrollingContainer__1CZkB","hideOnSmallScreen":"products_hideOnSmallScreen__gR_BI"};

/***/ }),

/***/ 23496:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"search_headerContainer__YikA5","hideOnSmallScreen":"search_hideOnSmallScreen__IYQ7z","infiniteScrollContainer":"search_infiniteScrollContainer__mcZh_","defaultContainer":"search_defaultContainer__teCYP","imageContainer":"search_imageContainer__ywCPy","img":"search_img__iS1cy","emptyText":"search_emptyText__2U4FY","infoWindow":"search_infoWindow__X0xAU","fade":"search_fade___KPSE"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5937,9866,1228,4617,5445,3609,260,2013,3253,3996,4843,6864,9950,7730,9878,3231,9774,2888,179], function() { return __webpack_exec__(16395), __webpack_exec__(32252); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);